
import { Component } from '@angular/core';

@Component({
  selector: 'relatives-contact-tab',
  template: `<contact-details-tab [enableCopy]="true"></contact-details-tab>`,
})
export class RelativesContactTabComponent { }
